import { api } from "../../../shared";

const url = "/api/suppliers";

async function get() {
  return api
    .inventar({
      method: "get",
      url,
    })
    .then((response) => response.data);
}

export const SupplierService = {
  get,
};
